import { Section } from 'components/shared/Section';
import { BLOG_COMMENTS } from 'lib/queries';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import main from 'utils/mutationWrapper';

import { CommentForm } from './CommentForm';
import { Comments } from './Comments';

const StyledCommentSection = styled.div`
  .title {
    font-size: 3rem;

    & > span {
      color: ${(props) => props.theme.primaryLink};
    }
  }
`;

export const CommentSection = ({ auth, articleId }) => {
  const [comments, setComments] = useState([]);

  useEffect(async () => {
    try {
      const response = await main(BLOG_COMMENTS, {
        input: {
          articleId: articleId
        }
      });

      setComments(response?.blogComments || []);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleNewComment = (comment) => {
    setComments((prevState) => [...prevState, comment]);
  };

  return (
    <StyledCommentSection>
      {
        <h2 className="title">
          Comments <span>({comments.length})</span>
        </h2>
      }
      <Section>
        <Comments
          auth={auth}
          articleId={articleId}
          allowReply={true}
          commentList={comments}
          onUpdate={handleNewComment}
        />
      </Section>

      <CommentForm auth={auth} articleId={articleId} onSubmit={handleNewComment} />
    </StyledCommentSection>
  );
};
